export class MaximumActiveStoreLocationsExceededException{}